import C from "./constants";

export const updateMiniplayerStatus = status => {
  return {
    type: C.UPDATE_MINIPLAYER_STATUS,
    payload: status
  };
};